import usePrivateAxios from "@/common/api/usePrivateAxios"
import { SendEstablishmentLeadEquipmentValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { useMutation } from "@tanstack/react-query"

interface UseSendEstablishmentLeadEquipment {
  establishmentLeadId?: string,
  onSuccess?: () => void,
  onError?: () => void
}

export const useSendEstablishmentLeadEquipment = ({ establishmentLeadId, onSuccess, onError }: UseSendEstablishmentLeadEquipment) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['sendEstablishmentLeadEquipment'],
    mutationFn: async (data: SendEstablishmentLeadEquipmentValidationSchema) => {
      const lead = {
        shipment_attributes: {
          ...data,
          status: 'shipped'
        }
      }

      await privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
